import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { GoogleCalendarAuthSuccess } from '../screens/googleCalendar/GoogleCalendarAuthSuccess'

export const Route = createFileRoute('/googleCalendarAuthSuccess')({
  component: GoogleCalendarAuthSuccess,
  validateSearch: z.object({
    redirectUrl: z.string().optional().catch(undefined),
    redirectAction: z.string().optional().catch(undefined),
  }),
})
